import { Component } from '@angular/core';

@Component({
  selector: 'app-edicaodedependentes',
  templateUrl: './edicaodedependentes.component.html',
  styleUrls: ['./edicaodedependentes.component.scss']
})
export class edicaodedependentesComponent { }